import { API_REQUEST_TYPES } from "../../enums";
import { resetApi } from "../../services/axios";
import { API } from "../endpoints";

export interface InitiativeListItem {
  id: string;
  title: string;
  type: string;
  summary: string;
  plannedDeliveryDate: string;
  isPublic: boolean;
  toolName?: string;
}

export interface GetInitiativesResponse {
  success: boolean;
  data?: InitiativeListItem[];
  message?: string;
}

export function getInitiatives(_variables?: void) {
  return async function (dispatch: any): Promise<GetInitiativesResponse> {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.INITIATIVES.LIST,
        config: {
          validateUser: true,
          notifyError: false,
        },
      })
    );
    return res;
  };
}

export interface CreateInitiativePayload {
  title: string;
  type: string;
  toolName?: string;
  summary: string;
  plannedDeliveryDate: string;
  isPublic: boolean;
}


export interface CreateInitiativeResponse {
  success: boolean;
  data?: { id?: string;[key: string]: unknown };
  message?: string;
}

export function createInitiative(payload: CreateInitiativePayload) {
  return async function (dispatch: any): Promise<CreateInitiativeResponse> {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.INITIATIVES.CREATE,
        payload,
        config: {
          validateUser: true,
          notifyError: true,
          notifySuccess: true,
          successMessage: "Active project created successfully",
        },
      })
    );
    return res;
  };
}

export interface UpdateInitiativePayload extends CreateInitiativePayload {}

export function updateInitiative(id: string, payload: UpdateInitiativePayload) {
  return async function (dispatch: any): Promise<CreateInitiativeResponse> {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.INITIATIVES.UPDATE(id),
        payload,
        config: {
          validateUser: true,
          notifyError: true,
          notifySuccess: true,
          successMessage: "Active project updated successfully",
        },
      })
    );
    return res;
  };
}

export function deleteInitiative(id: string) {
  return async function (dispatch: any): Promise<{ success: boolean; message?: string }> {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.DELETE,
        url: API.INITIATIVES.DELETE(id),
        config: {
          validateUser: true,
          notifyError: true,
          notifySuccess: true,
          successMessage: "Active project deleted successfully",
        },
      })
    );
    return res;
  };
}

export interface SuggestObjectivePayload {
  title?: string;
  type?: string;
  summary?: string;
}


export interface SuggestObjectiveResponse {
  success: boolean;
  data?: { suggestion: string };
  message?: string;
}

export function getObjectiveSuggestion(payload: SuggestObjectivePayload) {
  return async function (dispatch: any): Promise<SuggestObjectiveResponse> {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.INITIATIVES.SUGGEST_OBJECTIVE,
        payload,
        config: {
          validateUser: true,
          notifySuccess: false,
          notifyError: false,
        },
      })
    );
    return res;
  };
}
